import { render, staticRenderFns } from "./DealForm.vue?vue&type=template&id=145c7751&scoped=true&"
import script from "./DealForm.vue?vue&type=script&lang=js&"
export * from "./DealForm.vue?vue&type=script&lang=js&"
import style0 from "./DealForm.vue?vue&type=style&index=0&id=145c7751&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c7751",
  null
  
)

export default component.exports